import React from 'react';

export const DISTRIBUTION_MODEL_OPTIONS = Object.freeze([
  {
    value: 'svod',
    label: 'SVOD',
    title: 'Subscription',
    description: 'Subscription Video on Demand — viewers stream the title as part of an eligible paid WatchVIM subscription.',
  },
  {
    value: 'tvod',
    label: 'TVOD',
    title: 'Rental / Purchase',
    description: 'Transactional Video on Demand — viewers pay for an individual rental or purchase when that transaction type is available.',
  },
  {
    value: 'avod',
    label: 'AVOD',
    title: 'Free with Ads',
    description: 'Advertising Video on Demand — viewers can watch free with advertising on eligible WatchVIM placements.',
  },
]);

export function formatDistributionModels(models) {
  if (!Array.isArray(models)) return '';
  const allowed = new Set(DISTRIBUTION_MODEL_OPTIONS.map((item) => item.value));
  return [...new Set(models.map((value) => String(value || '').trim().toLowerCase()).filter((value) => allowed.has(value)))]
    .map((value) => value.toUpperCase())
    .join(' + ');
}

export default function DistributionModelSelector() {
  return (
    <fieldset className="business-card distribution-model-selector">
      <legend className="business-kicker">WatchVIM offer model</legend>
      <h3>How would you like this title offered?</h3>
      <p>Select one or more options. You may choose SVOD, TVOD, AVOD, or all three.</p>
      <div className="business-field-row three" aria-label="Requested offer models">
        {DISTRIBUTION_MODEL_OPTIONS.map((option) => (
          <label className="business-check distribution-model-choice" key={option.value}>
            <input name="distribution_models" type="checkbox" value={option.value} />
            <span>
              <strong>{option.label} — {option.title}</strong>
              <br />
              <small>{option.description}</small>
            </span>
          </label>
        ))}
      </div>
      <p className="business-fineprint">
        At least one offer model is required. Your selection is a distribution preference and remains subject to WatchVIM review,
        rights, platform availability, and final approval.
      </p>
    </fieldset>
  );
}
